import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { ADMIN_CONFIG } from '../../../../environments/environment';
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})

export class OtpService {
    private baseUrl = `${ADMIN_CONFIG.apiEndpoint}authAdmin`;

    constructor(private http: HttpClient) {}

    /**
     * Envoie un OTP via l'email et le mot de passe de l'admin
     */
    sendOtp(email: string, password: string): Observable<string> {
        const params = new HttpParams()
            .set('email', email)
            .set('password', password);
        localStorage.clear();

        return this.http.get<string>(`${this.baseUrl}/login`, {
            params,
            responseType: 'text' as 'json'  // 👈 important
        });
    }

    sendOtp1(email: string, password: string): Observable<string> {
        const params = new HttpParams()
            .set('email', email)
            .set('password', password);

        return this.http.get<string>(`${this.baseUrl}/login`, { params });
    }
    /**
     * Valide l'OTP envoyé
     */
    validateOtp(email: string, otp: string): Observable<boolean> {
        const params = new HttpParams()
            .set('email', email)
            .set('otp', otp);

        return this.http.get<boolean>(`${this.baseUrl}/validate`, { params }).pipe(
            tap(response => {
                console.log('[validateOtp] Réponse reçue :', response);
            }),
            catchError(error => {
                console.error('[validateOtp] Erreur :', error);
                return throwError(() => error);
            })
        );
    }
}
